import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, StatusChip, LoadingBlock } from "@/components/Common";
import { Card, CardContent } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { PlugZap } from "lucide-react";

export default function Integrations() {
    const [items, setItems] = useState(null);
    const [q, setQ] = useState("");

    const load = async () => {
        const { data } = await api.get("/integrations");
        setItems(data);
    };
    useEffect(() => {
        load();
    }, []);

    const toggle = async (it) => {
        await api.patch(`/integrations/${it.id}/toggle`, { enabled: !it.enabled });
        toast.success(`${it.name} ${!it.enabled ? "connected" : "disconnected"}`);
        load();
    };

    if (!items) return <LoadingBlock rows={8} />;

    const filtered = items.filter(
        (i) =>
            !q ||
            i.name.toLowerCase().includes(q.toLowerCase()) ||
            i.category.toLowerCase().includes(q.toLowerCase()),
    );
    const byCat = filtered.reduce((acc, i) => ((acc[i.category] = [...(acc[i.category] || []), i]), acc), {});

    return (
        <>
            <PageHeader
                title="Integrations Hub"
                subtitle="Connect to PMS, channel managers, OTAs, payments, locks, POS, IoT, accounting, CRM, and more."
                actions={<Input placeholder="Search…" value={q} onChange={(e) => setQ(e.target.value)} className="w-56" data-testid="integrations-search" />}
            />
            <div className="space-y-5">
                {Object.entries(byCat).map(([cat, list]) => (
                    <div key={cat}>
                        <div className="text-xs uppercase tracking-wider text-muted-foreground mb-2">{cat}</div>
                        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
                            {list.map((it) => (
                                <Card key={it.id} data-testid="integration-card">
                                    <CardContent className="py-4">
                                        <div className="flex items-start justify-between gap-3">
                                            <div className="flex items-start gap-3">
                                                <div className="w-9 h-9 rounded-lg bg-secondary grid place-items-center">
                                                    <PlugZap className="w-4 h-4 text-muted-foreground" />
                                                </div>
                                                <div>
                                                    <div className="text-sm font-semibold">{it.name}</div>
                                                    <div className="text-xs text-muted-foreground">{it.description}</div>
                                                </div>
                                            </div>
                                            <StatusChip status={it.status} />
                                        </div>
                                        <div className="flex items-center justify-between mt-3">
                                            <div className="text-[11px] text-muted-foreground">
                                                {it.last_sync ? `Last sync ${new Date(it.last_sync).toLocaleString()}` : "Never synced"}
                                            </div>
                                            <Switch checked={it.enabled} onCheckedChange={() => toggle(it)} data-testid="integration-enabled-toggle" />
                                        </div>
                                    </CardContent>
                                </Card>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}
